import { Switch, useColorMode } from '@chakra-ui/react'

const ThemeToggler = () => {
  const { toggleColorMode, colorMode } = useColorMode()
  const isChecked = colorMode === 'dark'
  return <Switch isChecked={isChecked} onChange={toggleColorMode} />
}

export default ThemeToggler
